import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/de";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageBody from "./components/page/PageBody";
import PageFooter from "./components/page/PageFooter";
import { ConfirmationDialogProvider } from "./components/ConfirmationDialog/ConfirmationDialogProvider";

function App(props) {
    return (
        <React.Fragment>
            <ToastContainer style={{ height: "50px" }} />
            <ConfirmationDialogProvider>
                <div className="page">
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                        <PageBody {...props} />
                        <PageFooter />
                    </MuiPickersUtilsProvider>
                </div>
            </ConfirmationDialogProvider>
        </React.Fragment>
    );
}

export default App;
